import { render } from "./JournalAttachments.vue?vue&type=template&id=4eef4d12"
import script from "./JournalAttachments.vue?vue&type=script&lang=js"
export * from "./JournalAttachments.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__